import 'swiper/css';
import 'swiper/css/autoplay';
import { Autoplay, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Buttons } from './components/buttons';
import { CloseIcon } from './components/close-icon';
import { Description } from './components/description';
import { Image } from './components/image';
import { Pagination } from './components/pagination';
import { ProductReleaseTag } from './components/product-release-tag';
import { ReleaseDate } from './components/release-date';
import { ReleaseTitle } from './components/release-title';
import {
  StyledDialog,
  StyledDialogPaperInner,
  StyledSlideContentFlex,
  StyledSwiperWrapper,
} from './styled';
import { WhatsNewModalProps } from './types';

export const WhatsNewModalDesktop = ({
  data,
  open,
  onClose,
  activeIndex,
  slideCount,
  handleSlideChange,
  handleSwiper,
  handleBulletClick,
}: WhatsNewModalProps) => {
  const handleClose = () => {
    onClose();
  };

  return (
    <StyledDialog
      open={open}
      onClose={(_event, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
        handleClose();
      }}
      variant="bare"
      fullWidth
    >
      <Image src={data.at(activeIndex)?.releaseImage} />
      <StyledDialogPaperInner>
        <CloseIcon onClick={handleClose} />
        <StyledSwiperWrapper>
          <Swiper
            initialSlide={0}
            slidesPerView={1}
            spaceBetween={0}
            allowTouchMove={false}
            onSlideChange={(swiper) => handleSlideChange(swiper.realIndex)}
            onSwiper={handleSwiper}
            modules={[Autoplay, Navigation]}
            autoplay={{
              delay: 10000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            loop={true}
          >
            {data.map((release) => (
              <SwiperSlide key={release.releaseId}>
                <ProductReleaseTag />
                <ReleaseDate
                  date={release.releaseDate}
                  subtitle={release.subtitle}
                />
                <ReleaseTitle title={release.releaseTitle} />
                <StyledSlideContentFlex>
                  <Description description={release.descriptions} />
                  <Buttons
                    primaryButtonText={release.primaryButtonText}
                    primaryButtonHref={release.primaryButtonHref}
                    isSecondaryButtonVisible={release.isSecondaryButtonVisible}
                    secondaryButtonText={release.secondaryButtonText}
                    secondaryButtonHref={release.secondaryButtonHref}
                    onClose={handleClose}
                  />
                </StyledSlideContentFlex>
              </SwiperSlide>
            ))}
          </Swiper>
        </StyledSwiperWrapper>
        <Pagination
          activeIndex={activeIndex}
          slideCount={slideCount}
          onBulletClick={handleBulletClick}
        />
      </StyledDialogPaperInner>
    </StyledDialog>
  );
};
